// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__8CrNO","buttonsWrapper":"ForgotPassword_buttonsWrapper__1lwiD"};